import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from '@src/lib/api'
import { Company, CompanyResponseDTO } from '@src/types/companies'
import { ListResponseDTO } from '@src/types/api'

export const companiesApi = createApi({
  reducerPath: 'companiesApi',
  baseQuery: baseQueryConfig('/companies'),
  endpoints: build => ({
    getCompanies: build.query<ListResponseDTO<Company>, void>({
      query: () => ({
        url: '/'
      })
    }),
    getActualCompanies: build.query<ListResponseDTO<CompanyResponseDTO>, void>({
      query: () => ({
        url: '/actual'
      })
    }),
  })
})

export const {
  useGetCompaniesQuery,
  useGetActualCompaniesQuery
} = companiesApi